import { render, staticRenderFns } from "./advanceSettings.vue?vue&type=template&id=8d7f9d80&scoped=true"
import script from "./advanceSettings.vue?vue&type=script&lang=js"
export * from "./advanceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7f9d80",
  null
  
)

export default component.exports